<template>
  <el-dialog
    :title="$t('addComplaintType.title')"
    :visible.sync="visible"
    width="650px"
    :close-on-click-modal="false"
    @close="handleClose"
    custom-class="complaint-type-modal"
  >
    <div class="modal-header">
      <span class="modal-title">{{ $t('addComplaintType.title') }}</span>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="86px"
      class="complaint-type-form"
    >
      <el-form-item :label="$t('addComplaintType.community')" prop="communityId" required>
        <el-select
          v-model="form.communityId"
          :placeholder="$t('addComplaintType.communityPlaceholder')"
          style="width: 516px"
        >
          <el-option
            v-for="item in communityList"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('addComplaintType.typeName')" prop="typeName" required>
        <el-input
          v-model="form.typeName"
          :placeholder="$t('addComplaintType.typeNamePlaceholder')"
          style="width: 516px"
        />
      </el-form-item>

      <el-form-item :label="$t('addComplaintType.notifyWay')" prop="notifyWay" required>
        <el-select
          v-model="form.notifyWay"
          :placeholder="$t('addComplaintType.notifyWayPlaceholder')"
          style="width: 516px"
        >
          <el-option
            v-for="item in notifyWayOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('addComplaintType.appraiseReply')" prop="appraiseReply" required>
        <el-select
          v-model="form.appraiseReply"
          :placeholder="$t('addComplaintType.appraiseReplyPlaceholder')"
          style="width: 516px"
        >
          <el-option
            v-for="item in appraiseReplyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('addComplaintType.remark')" prop="remark">
        <el-input
          v-model="form.remark"
          :placeholder="$t('addComplaintType.remarkPlaceholder')"
          style="width: 516px"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancel-btn" @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button class="save-btn" type="primary" @click="handleSubmit" :loading="loading">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveComplaintType } from '@/api/oa/addComplaintTypeApi'
import { getEffectiveCommunityId, getMyEnteredCommunitys } from '@/api/community/communityApi'

export default {
  name: 'AddComplaintTypeModal',
  data() {
    return {
      visible: false,
      loading: false,
      communityId: '',
      communityList: [],
      form: {
        communityId: '',
        typeName: '',
        notifyWay: '',
        appraiseReply: '',
        remark: ''
      },
      notifyWayOptions: [
        { value: 'SMS', label: this.$t('addComplaintType.sms') },
        { value: 'WECHAT', label: this.$t('addComplaintType.wechat') },
        { value: 'WORK_LICENSE', label: this.$t('addComplaintType.workLicense') }
      ],
      appraiseReplyOptions: [
        { value: 'Y', label: this.$t('addComplaintType.autoReply') },
        { value: 'N', label: this.$t('addComplaintType.manualReply') }
      ],
      rules: {
        communityId: [
          { required: true, message: this.$t('addComplaintType.communityRequired'), trigger: 'change' }
        ],
        typeName: [
          { required: true, message: this.$t('addComplaintType.typeNameRequired'), trigger: 'blur' }
        ],
        notifyWay: [
          { required: true, message: this.$t('addComplaintType.notifyWayRequired'), trigger: 'change' }
        ],
        appraiseReply: [
          { required: true, message: this.$t('addComplaintType.appraiseReplyRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async open() {
      this.communityId = getEffectiveCommunityId()
      this.form = {
        communityId: getEffectiveCommunityId(this.communityId),
        typeName: '',
        notifyWay: '',
        appraiseReply: '',
        remark: ''
      }
      await this.loadCommunityList()
      this.visible = true
    },
    async loadCommunityList() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communityList = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        console.error('获取小区列表失败:', error)
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        try {
          this.loading = true
          const res = await saveComplaintType(this.form)
          if (res.code === 0) {
            this.$message.success(this.$t('common.operationSuccess'))
            this.$emit('success')
            this.visible = false
          } else {
            this.$message.error(res.msg)
          }
        } catch (error) {
          console.error('保存投诉类型失败:', error)
          this.$message.error(this.$t('common.saveFailed'))
        } finally {
          this.loading = false
        }
      })
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .complaint-type-modal {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 24px;
    border-top: 1px solid #EBF2FA;
  }
}

.modal-header {
  height: 66px;
  background: #EBF2FA;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #DCE6F5;

  .modal-title {
    font-size: 16px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 600;
    color: #1D2129;
  }
}

.complaint-type-form {
  padding: 24px 24px 0;

  ::v-deep .el-form-item__label {
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;
    color: #1D2129;
    text-align: right;
    padding-right: 8px;

    &::before {
      color: #FB2C36;
      margin-right: 2px;
    }
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-radius: 10px;
    border: 1px solid #DCE6F5;
    font-size: 14px;
    font-family: 'Inter', 'PingFang SC', sans-serif;
    color: #1D2129;

    &::placeholder {
      color: #8C9BB4;
    }

    &:focus {
      border-color: #0E76FF;
    }
  }

  ::v-deep .el-input__inner {
    height: 38px;
    line-height: 38px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .cancel-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    border: 1px solid #0E76FF;
    background: #FFFFFF;
    color: #0E76FF;
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;

    &:hover {
      background: #E8F3FF;
    }
  }

  .save-btn {
    width: 98px;
    height: 38px;
    border-radius: 10px;
    background: #0E76FF;
    border: none;
    color: #FFFFFF;
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;

    &:hover {
      background: #1C99FF;
    }
  }
}
</style>
